export default __webpack_public_path__ + "static/media/our-team-04.abfb9434.jpg";